export const parseSRT = (content) => {
    const subtitleBlocks = content.trim().split(/\n\s*\n/);
    return subtitleBlocks.map((block) => {
        const lines = block.split('\n');
        if (lines.length < 3) return null;

        const id = lines[0].trim();
        const timecodeLine = lines[1].trim();
        const text = lines.slice(2).join('\n').trim();

        const [start, end] = timecodeLine.split(' --> ');

        return {
            id,
            start,
            end,
            startTime: timeToSeconds(start),
            endTime: timeToSeconds(end),
            text
        };
    }).filter(block => block !== null);
};

export const jsonToSRT = (subtitles) => {
    return subtitles.map((sub, index) => {
        return `${index + 1}\n${sub.start} --> ${sub.end}\n${sub.text}`;
    }).join('\n\n');
};

const timeToSeconds = (timeString) => {
    if (!timeString) return 0;
    const [time, ms] = timeString.split(',');
    const [hours, minutes, seconds] = time.split(':').map(Number);
    return (hours * 3600) + (minutes * 60) + seconds + (parseInt(ms) / 1000);
};

export const secondsToSRTTime = (seconds) => {
    const date = new Date(0);
    date.setSeconds(seconds);
    const timeString = date.toISOString().substr(11, 8);
    const ms = Math.floor((seconds % 1) * 1000).toString().padStart(3, '0');
    return `${timeString},${ms}`;
};
